import { makeConnectedNavbar } from "features/navbar";

import Component from "./components/ParentNavbar";

export default makeConnectedNavbar(Component);
